import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { VueFormInputProps } from '@/composables/useFormInputData';
import DateInput from './DateInput.vue';
import { onMounted, ref, computed, useTemplateRef } from 'vue';
import InformationBox from '../InformationBox/InformationBox.vue';
import { InformationBoxTypes } from '@/interfaces/forms/information-box.interface';
import { useReferenceDataStore } from '@/store';
import { dateOfBirthIsValid } from '@/utils/formkit-helpers';


export default /*@__PURE__*/_defineComponent({
  __name: 'DateOfBirth',
  props: {
    bindings: {},
    isPolicyholder: { type: Boolean },
    isDriver: { type: Boolean },
    invalidDobWarning: {},
    maxDateByDays: {},
    minDate: {},
    dateMustBefore: {},
    dateMustAfter: {}
  },
  setup(__props: any) {

const props = __props;

const minAge = ref<string | undefined>();
const dob = ref<string>();
const modifiedBindings = ref<any>();
const outerClass = ref<string>();

const inputRef = useTemplateRef('input-ref');

const refDataStore = useReferenceDataStore();

onMounted(async () => {
  // Fetch policyholder / driver min. age
  const configs = await refDataStore.getIQConfigSettings();
  if (props.isPolicyholder) {
    minAge.value = configs.find((c) => c.name == 'MinPolicyholderAge')?.value;
  } else if (props.isDriver) {
    minAge.value = configs.find((c) => c.name == 'MinDriverAge')?.value;
  }
  // fallback to default 16
  if (!minAge.value) minAge.value = '16';

  outerClass.value = props.bindings.outerClass;
  modifiedBindings.value = props.bindings;
  modifiedBindings.value.outerClass = '';
});

const showinvalidDobWarning = computed(() => {
  if (!dob.value) {
    return false;
  }
  if (!inputRef.value?.inputRef?.node || inputRef.value.inputRef.node?.context?.state?.invalid) {
    return false;
  }
  try {
    return !dateOfBirthIsValid(dob.value, Number(minAge.value));
  } catch (error) {
    console.error(error);
    return false;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col", outerClass.value])
  }, [
    (modifiedBindings.value)
      ? (_openBlock(), _createBlock(DateInput, {
          key: 0,
          ref: "input-ref",
          modelValue: dob.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dob).value = $event)),
          bindings: modifiedBindings.value,
          maxDateByDays: _ctx.maxDateByDays,
          minDate: _ctx.minDate,
          dateMustBefore: _ctx.dateMustBefore,
          dateMustAfter: _ctx.dateMustAfter
        }, null, 8, ["modelValue", "bindings", "maxDateByDays", "minDate", "dateMustBefore", "dateMustAfter"]))
      : _createCommentVNode("", true),
    (_ctx.invalidDobWarning && showinvalidDobWarning.value)
      ? (_openBlock(), _createBlock(InformationBox, {
          key: 1,
          type: _unref(InformationBoxTypes).WARNING,
          description: _ctx.invalidDobWarning,
          class: "mt-8 md:mt-6"
        }, null, 8, ["type", "description"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})